import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-heart",
  "use": "icon-heart-usage",
  "viewBox": "0 0 1000 1000",
  "content": "<symbol viewBox=\"0 0 1000 1000\" id=\"icon-heart\"><path d=\"M286 81q-60 0-110.5 30T95 192 65 303q0 48 7 87 13 70 49 139 102 196 377 352 274-156 377-352 36-69 48-139 7-38 7-88 0-60-29.5-110.5T820 111 710 81q-40 0-76.5 13.5T567 133l-69 58-69-58q-30-25-67-38.5T286 81zm212 866l-14-8Q183 772 69 555q-40-77-54-155-8-43-8-96v-1q0-75 38-140Q82 99 145 62q65-38 141-38 49 0 95.5 17T466 90l32 26 32-26q37-32 83.5-49T710 24q75 0 140 38 63 37 100 100 38 65 38 140 0 54-8 97-14 79-54 156-114 217-414 384z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/heart.svg
// module id = 1128
// module chunks = 2